// 预订转入住
import { MemberLevel, OccType, SourceChannelType } from '@/config/constant';
import { CheckInByReserveAction } from '@/redux/actions/reservation/constant';
import {
  CommonBase,
  RentTimeInfo,
  ConfigRoomPrice,
  RoomCategory,
  RentRoomInfo,
  RemarkInfo,
  NoticeInfo,
  CheckInGuestInfo,
  RoomItem,
  SourceChannelFullInfo,
  ChannelItem,
} from './base.d';

// 公共信息
export interface CommonInfo extends CommonBase {
  isAppendMode: boolean; // 是否追加入住
  mainOrderId?: string; // 主订单id
}

// 预订房间信息
export interface ReserveCheckInRoomInfo extends RentRoomInfo {
  recNo: string; // 子单号
  priceChannel: SourceChannelType; // 渠道类型(判断用券)
}

export interface MainState {
  commonInfo: CommonInfo; // 基础信息
  allGuestList: CheckInGuestInfo[]; // 入住人列表
  rentTimeInfo: RentTimeInfo; // 入住日期
  channelInfo: SourceChannelFullInfo; // 客源渠道
  remarkInfo: RemarkInfo; // 备注
  rentRoomInfos: ReserveCheckInRoomInfo[]; // 入住房信息
}

export interface ReducerState extends MainState {
  isInit: boolean; // 初始化
  isLoading: boolean; // 加载中
  isModify: boolean; // 是否有修改
  allRoomList: RoomCategory[]; // 可选房间
  roomPriceList: ConfigRoomPrice[]; // 房价信息
  cardReadNotice: NoticeInfo; // 证件读取提示
  originRoomList: RoomItem[]; // 预订单选择的房间
  originCouponList: string[]; // 之前选中的券
  channelList: ChannelItem[]; // 渠道列表
}

const initialState: Partial<ReducerState> = {
  isInit: false,
  isLoading: true,
  isModify: false,
  commonInfo: {
    occType: OccType.DayUse,
    memberLevel: MemberLevel.Common,
    isAppendMode: false,
  },
};

type ActionHandler<T> = (state: ReducerState, action: { payload: T }) => ReducerState;

const reducerMap = {
  [CheckInByReserveAction.initDefaultState]: <ActionHandler<Partial<ReducerState>>>((
    state,
    { payload },
  ) => {
    return { ...state, ...payload };
  }),
  [CheckInByReserveAction.setLoadingStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isLoading: payload };
  }),
  [CheckInByReserveAction.setChannelList]: <ActionHandler<ChannelItem[]>>((state, { payload }) => {
    return { ...state, channelList: payload };
  }),
  [CheckInByReserveAction.setInitStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isInit: payload };
  }),
  [CheckInByReserveAction.setModifyStatus]: <ActionHandler<boolean>>((state, { payload }) => {
    return { ...state, isModify: payload };
  }),
  [CheckInByReserveAction.setGuestData]: <ActionHandler<CheckInGuestInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, allGuestList: payload };
  }),
  [CheckInByReserveAction.setRentTimeInfo]: <ActionHandler<Partial<RentTimeInfo>>>((
    state,
    { payload },
  ) => {
    const { rentTimeInfo } = state;
    return { ...state, rentTimeInfo: { ...rentTimeInfo, ...payload } };
  }),
  [CheckInByReserveAction.setAllRoomList]: <ActionHandler<RoomCategory[]>>((state, { payload }) => {
    return { ...state, allRoomList: payload };
  }),
  [CheckInByReserveAction.setRentRoomList]: <ActionHandler<ReserveCheckInRoomInfo[]>>((
    state,
    { payload },
  ) => {
    return { ...state, rentRoomInfos: payload };
  }),
  [CheckInByReserveAction.setRoomPriceList]: <ActionHandler<ConfigRoomPrice[]>>((
    state,
    { payload },
  ) => {
    return { ...state, roomPriceList: payload };
  }),
  [CheckInByReserveAction.setRemarkInfo]: <ActionHandler<Partial<RemarkInfo>>>((
    state,
    { payload },
  ) => {
    const { remarkInfo } = state;
    return { ...state, remarkInfo: { ...remarkInfo, ...payload } };
  }),
  [CheckInByReserveAction.setCardNotice]: <ActionHandler<NoticeInfo>>((state, { payload }) => {
    return { ...state, cardReadNotice: payload };
  }),
  [CheckInByReserveAction.setOriginCouponList]: <ActionHandler<string[]>>((state, { payload }) => {
    return { ...state, originCouponList: payload };
  }),
};

export const reducerMapper = (state = initialState, action) => {
  const actionType = action.type;
  const reducer = reducerMap[actionType];
  if (typeof reducer === 'function') {
    return reducer(<ReducerState>state, action);
  }
  return state;
};

export const storeName = 'checkInByReserve';
